module.exports = __webpack_public_path__ + "static/media/windy.2916146d.webp";